//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'RRF',
  data() {
    return {
      form: {
        item1: '',
        item2: '',
        item3: '',
        item4: '',
      },
      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res = (form.item1 * form.item2) / (form.item3 * form.item4)
        self.hasScore = true
        return String(res.toFixed(1))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/RRF.vue